import { Box, Typography, Card, Avatar, CardContent, Link } from "@mui/joy";
import { useTranslation } from "../../../i18n";
import { useUserListQuery } from "../../../__generated__/types-and-hooks";
import { Link as RouterLink } from "react-router-dom";
// import CountryFlag from "../../../components/CountryFlag";

export default function Network() {
  const t = useTranslation();
  const { data, loading } = useUserListQuery();

  return (
    <>
      <Box sx={{ m: 2 }}>
        <Typography sx={{ flex: 1 }} level="body-sm">
          {t("Connect with other users")}
        </Typography>
      </Box>
      <Box sx={{ m: 2 }}>
        {loading && "Loading..."}
        {!loading && (
          <Box
            sx={{
              width: "100%",
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fill, minmax(min(100%, 200px), 1fr))",
              gap: 2,
              marginBottom: 3,
            }}
          >
            {(data?.user_list ?? []).map((user) => (
              <Card
                key={user.id}
                variant="outlined"
                orientation="horizontal"
                sx={{
                  background: "hsl(0deg 0% 31.06% / 35%)",
                  "&:hover": {
                    boxShadow: "md",
                    borderColor: "neutral.outlinedHoverBorder",
                    background: "hsl(0deg 0% 51.06% / 35%)",
                  },
                }}
              >
                <Avatar
                  size="sm"
                  sx={{
                    height: 36,
                    // width: "100%",
                    minWidth: 36,
                    width: 36,
                    borderRadius: "50%",
                  }}
                  src={user.picture ?? "/images/qcsku_dark.jpg"}
                />
                <CardContent>
                  <Typography level="title-lg" id="card-description">
                    {user.firstName} {user.lastName}
                  </Typography>
                  <Typography
                    level="body-sm"
                    aria-describedby="card-description"
                    sx={{ mb: 1 }}
                  >
                    <Link
                      component={RouterLink}
                      color="neutral"
                      to={"/user/" + user.slug}
                      overlay
                      underline="none"
                      sx={{ color: "text.tertiary" }}
                      gap={1}
                    >
                      {user.slug}
                    </Link>
                    {/* <CountryFlag code={user.countryCode} /> */}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
}
